{
  "version": 1,
  "asset_id": "4cfab73d-dea2-4808-beb5-e8e17d82347a",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/4cfab73d-dea2-4808-beb5-e8e17d82347a/homosassa-blue-metal-roof-installation-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/4cfab73d-dea2-4808-beb5-e8e17d82347a/homosassa-blue-metal-roof-installation-1320w.webp",
  "original_filename": "homosassa-blue-metal-roof-installation-1320w.webp",
  "size": 138314,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
